import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, HashRouter, Route, Switch } from "react-router-dom";
import Home from './pages/home.jsx'
import Vehicles from './pages/Vehicles.jsx'
import Cotizaziones from './pages/Cotizaciones.jsx'
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'


class Root extends Component {
    render() {
        return (
            <Router>
                <Switch>
                <Route path="/cotizaciones" component={Cotizaziones} />
                    <Route path="/vehicles" component={Vehicles} />
                    <Route exact path="/" component={Home} />
                </Switch>
            </Router>
        )
    }
}

export default Root;

ReactDOM.render(<Root />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js